// extracted by mini-css-extract-plugin
export default {"mCard":"KC-z","image":"LC-z","imageNoBackground":"MC-z","imageHasCategory":"NC-z","fullWidth":"OC-z"};